import { ConstantRole } from '../models/constant-role.model';

/** Support app roles (not loaded from Admin Firestore constants). */
export type SupportRoleId = 'admin' | 'agent';

export const SUPPORT_ROLES: ConstantRole[] = [
  { id: 'admin', level: 10, text: 'Administrator' },
  { id: 'agent', level: 20, text: 'Agent' },
];

/** Normalizes Firestore employee role to support app roles (admin | agent only). */
export function normalizeSupportRoleId(role: string | null | undefined): SupportRoleId {
  const r = (role || 'agent').toLowerCase();
  if (r === 'admin') return 'admin';
  return 'agent';
}
